<!-- apps/web/src/components/icons/IconSources.vue -->
<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <circle cx="6" cy="6" r="3"/>
    <circle cx="18" cy="6" r="3"/>
    <circle cx="12" cy="18" r="3"/>
    <path d="M9 7l3 8M15 7l-3 8"/>
  </svg>
</template>
